import { render, staticRenderFns } from "./clubVoting.vue?vue&type=template&id=000f1c51&scoped=true&"
import script from "./clubVoting.vue?vue&type=script&lang=js&"
export * from "./clubVoting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000f1c51",
  null
  
)

export default component.exports